<app-button-feedback
  [_setId]="'btnDownloadFile_' + result.id"
  *ngIf="result.attributes.finished === 1 && result.attributes.successful === 1"
  (click)="downloadFile(result.attributes.result_id)"
  [_defaultButtonText]="'jobresult-download.download_file'"
  [_responseText]="fileDownloadResponse | async"
  [_setIcon]="faDownload"
></app-button-feedback>
